/**
 * @name user-agent.constants
 * @description Core user agent in ngx-responsive
 *
 * @license MIT
 */

export const USER_AGENT = {
    device: null,
    browser: null,
    pixelratio: null,
    ie_version: {
        name: null,
        state: null
    },
    game_device: {
        name: null,
        state: null
    },
    smart_tv: {
        name: null,
        state: null
    },
    desktop: {
        name: null,
        state: null
    },
    tablet: {
        name: null,
        state: null
    },
    mobile: {
        name: null,
        state: null
    },
    window_os: {
        name: null,
        state: null
    },
    linux_os: {
        name: null,
        state: null
    },
    bot: null
};
